const accordions = document.querySelectorAll(".accordion");

if(accordions) {
    accordions.forEach(function (accordion) {
        const items = accordion.querySelectorAll(".accordion-item");
        items.forEach(function (item) {
            item.addEventListener("click", function () {
                const target = this.dataset.target;
                const targetElement = document.querySelector("#" + target);
                targetElement.classList.toggle("d-none");

                this.querySelector(".plus").classList.toggle("d-none");
                this.querySelector(".minus").classList.toggle("d-none");
            });
        });
    });
}
